import * as ng from 'angular';
import {BaseUrlService} from '../../services/base-url.service';
import {ArchiSmallServices} from '../../services/archismall.service';
import {rabbitMQ} from '../../third/rabbitMQ';

class HomeController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    'ArchiSmallServices',
    'BaseUrlService'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: ng.ui.IStateService,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: ng.jwt.IJwtHelper,
    private ArchiSmallServices: ArchiSmallServices,
    private _baseService: BaseUrlService
  ) {
    $scope.tooltips = {
      'home': 'Torna alla pagina principale.',
      'fattura': 'Crea, carica, trasmetti o verifica le tue Fatture Elettroniche.',
      'conserva': 'Conserva a norma di legge i tuoi documenti informatici.\nPuoi anche ricercarli o scaricarli in caso di controllo di un pubblico ufficiale.',
      'archivia': 'Archivia, organizza, scarica e condividi tuoi documenti in tutta sicurezza.',
      'help': 'Ti serve Aiuto? Leggi il Manuale o apri un\nticket e verrai contattato dal Servizio Assistenza.',
      'notifications': 'ArchiSMALL ti tiene aggiornato sulle operazioni eseguite.\nClicca sulle singole notifiche per consultarle.',
      'user': 'Gestisci il tuo Profilo e la tua Rubrica.',
      'userSettings': 'Completa o modifica le informazioni relative al tuo account ArchiSMALL.',
      'rubrica': 'Aggiungi, modifica e gestisci i tuoi contatti.',
      'storageLimit': 'Controlla lo spazio del tuo ArchiSMALL.',
      'storicoUtilizzo': 'Controlla lo spazio utilizzato',
      'signOut': 'Esci da ArchiSMALL.',
      'admin': 'Admin'
    };

    $scope.getNotificationClass = (item) => {
      return {
        'icon-icon_scarica': item.type === 'archidrive' || item.type === 'archidrive-multiple',
        'icon-icon_consulta': item.type === 'conservato',
        'icon-icon_conserva': item.type === 'conservazione' || item.type === 'conservazione-fatture-attive'
          || item.type === 'conservazione-fatture-attive-versamento' || item.type === 'conservazione-fatture-pa-e-notifiche'
          || item.type === 'conservazione-fatture-attive-enabled' || item.type === 'conservazione-pec'
          || item.type === 'conservazione-pec-versamento' || item.type === 'conservazione-fattura-gse-e-notifiche'
          || item.type === 'conservazione-fatture-elettronica-passiva',
        'icon-icon_fattura': item.type === 'fattura-pa-status' || item.type === 'fattura-pr-status' || item.type === 'fattura-passiva-status',
        'icon-icon_aziende': item.type === 'azienda_tdoc'
      };
    };
    $scope.jwt = store.get('jwt');
    $scope.decodedJwt = $scope.jwt && jwtHelper.decodeToken($scope.jwt);

    if (!$rootScope.currentUser()) {
      $state.go('login');
    } else {
      ArchiSmallServices.getUser($rootScope.currentUser().sub)
        .then((response: any) => {
          $rootScope.user = response;
          store.set('user', response);
          $rootScope.user.organizationData.contactPerson.birthDate = $rootScope.formatDateValue($rootScope.user.organizationData.contactPerson.birthDate);
          $rootScope.user.organizationData.periodStart = $rootScope.formatDateValue($rootScope.user.organizationData.periodStart);
          $rootScope.user.organizationData.periodEnd = $rootScope.formatDateValue($rootScope.user.organizationData.periodEnd);
          if ($rootScope.user.organizationData.alboProfessionale !== undefined && $rootScope.user.organizationData.alboProfessionale.dataIscrizioneAlbo !== '') {
            $rootScope.user.organizationData.alboProfessionale.dataIscrizioneAlbo = $rootScope.formatDateValue($rootScope.user.organizationData.alboProfessionale.dataIscrizioneAlbo);
          }
          ArchiSmallServices.rabbitMQConfig()
            .then((response: any) => {
              rabbitMQ.init(response.user, response.password, configuration.testEnvironment);
              $rootScope.startNotificationWorker();
            }, (error) => {
              $rootScope.alert('error', error);
            });
          // rimuovere ArchiSmallServices.setBaseUrl($rootScope.user.accountData.serverInstance);
          // rimuovere _baseService.setBaseUrl($rootScope.user.accountData.serverInstance);
        }, (error) => {
          $rootScope.alert('error', error);
        });

      $scope.closeAlert = (index) => {
        store.set('showAlert', false);
      };
    }
    ArchiSmallServices.getNextSendToConservazioneDate()
      .then((response) => {
        $scope.nextSendToConservazioneDate = response[0];
      }, (error) => {
        $scope.nextSendToConservazioneDate = error;
      });
  }
}

export const HomeComponent: ng.IComponentOptions = {
  template: require('./home.html'),
  controller: HomeController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/home.ts